import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

import Box from '@mui/material/Box';
import { ACLS, AUTH_STATES, LOGO_URL } from '../constants';
import { useAuth } from '@timmons-group/shared-react-components/hooks';
import { Modal, AppBar } from '@timmons-group/shared-react-components';

const navLinks = [
  {
    title: 'Home',
    href: '/',
    permission: ACLS.SEE_HOME
  },
  {
    title: 'Explorer',
    href: '/explorer',
  },
  {
    title: 'Dashboard',
    href: '/dashboard',
  },
  {
    title: 'Recipients',
    href: '/recipients',
    permission: ACLS.SEE_RECIP,
  },
  {
    title: 'Search',
    href: '/search/units',
    permission: ACLS.SEE_SEARCH_PAGE,
  },
];

const Layout = () => {
  const [buildVersion, setbuildVersion] = useState({});
  // The useProvideAuth in useAuth.js contains the exposed properties and methods
  const { login, logout, refresh, authState } = useAuth();

  useEffect(() => {
    // I need to fetch buildInfo.json to get the build number
    const fetchBuild = async () => {
      try {
        const response = await fetch('/buildInfo.json');
        const data = await response.json();
        setbuildVersion(data);
      } catch (error) {
        console.log('Error fetching buildInfo.json', error);
      }
    };
    fetchBuild();
  }, []);

  return (
    <>
      <Box
        component="p"
        className={buildVersion ? 'version' : 'hidden'}
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 2 }}
      >
        {buildVersion ? `v${buildVersion?.frontendVersion || ''}.${buildVersion?.packageVersion || ''}`: ''}
      </Box>
      <AppBar
        navLinks={navLinks}
        user={authState?.user}
        onLogin={() => login()}
        onLogout={logout}
        logoUrl={LOGO_URL}
      />
      <Outlet />
      <Modal open={authState?.state === AUTH_STATES.TOKEN_STALE} okLabel="Continue" cancelLabel="Log Out" onCancel={logout} onOk={refresh}>
        <Box component="p" className="stale-token">It looks like your session is idle and your access token has expired. Click continue to keep using the system. </Box>
      </Modal>
      <Modal open={authState?.state === AUTH_STATES.REFRESHING_TOKEN || authState?.state === AUTH_STATES.LOGGING_IN} hideOk={true} hideCancel={true}>
        <Box component="p" className="stale-token">Refreshing your session...</Box>
      </Modal>
    </>
  );
};

export default Layout;
